import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IEventItem } from '@core/interfaces/ievent-item';
import { IModalData } from '@core/interfaces/imodal-data';
import { EventItemService } from '@core/services/event-item.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, take } from 'rxjs';
import { ConfirmCancelComponent } from '../shared/confirm-cancel/confirm-cancel.component';
import { IDragDropConfiguration } from '@core/interfaces/idrag-drop-configuration';
import { ScrollService } from '@core/services/scroll.service';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventsComponent {
  private subscriptions = new Subscription();
  events: any = [];
  isCollapsed = false;
  eventData: any;
  configuration: IDragDropConfiguration = {
    imageClass: 'large-event',
    nameClass: 'dark-red mt-2',
    imagePositionClass: 'd-flex justify-content-center',
    imageTagClass: 'profile-img-event',
    editable: true,
  };
  timePeriods = [
    'Bronze age',
    'Iron age',
    'Middle ages',
    'Early modern period',
    'Long nineteenth century',
  ];
  faPlusSquare = faPlusSquare;

  constructor(
    private eventItem: EventItemService,
    private scrollService: ScrollService,
    private modal: NgbModal) {}

  ngOnInit(): void {
    this.getEventItem();
    this.subscriptions.add(
      this.scrollService.scrollRequest$.subscribe((elementId) => {
        this.scrollToElement(elementId);
      })
    );
  }

  getEventItem() {
    this.subscriptions.add(
      this.eventItem
        .getAll()
        .pipe(take(1))
        .subscribe((res: any) => (this.events = res))
    );
    this.isCollapsed = false;
  }

  addEventItem() {
    this.isCollapsed = !this.isCollapsed;
    this.eventData = {};
  }

  edit(event: any): void {
    this.eventData = event;
    this.isCollapsed = true;
  }

  confirmDelete(data: any): void {
    const modalData: IModalData = {
      title: 'Confirm Delete',
      body: '<p>Are you sure you want to delete this event?</p>',
      cancelBtnText: 'Cancel',
      confirmBtnText: 'Confirm',
    };
    const modalRef = this.modal.open(ConfirmCancelComponent);
    modalRef.componentInstance.data = modalData;
    modalRef.result
      .then((_res: any) => {
        this.eventItem
          .deleteEvent(data.id, 'Event successfully deleted!')
          .pipe(take(1))
          .subscribe((res: any) => this.getEventItem());
      })
      .catch((_err: any) => false);
  }

  updateEventOrder(event: any): void {
    this.subscriptions.add(
      this.eventItem
        .updateEvent(this.events, 'Event order successfully updated!')
        .pipe(take(1))
        .subscribe()
    );
  }

  scrollToElement(elementId: string) {
    const targetElement = document.getElementById(elementId);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // drop(event: CdkDragDrop<string[]>) {
  //   moveItemInArray(this.events, event.previousIndex, event.currentIndex);
  //   this.events.forEach((aff: any, index: number) => {
  //     aff.sortOrder = index;
  //   });
  //   this.eventItem
  //     .updateEvent(this.events, 'Event order successfully updated!')
  //     .pipe(take(1))
  //     .subscribe();
  // }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
